import { useNode } from "@craftjs/core";
import { Minus } from "lucide-react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "./base";

function Preview({ ...props }) {
  const { connectors: { connect } } = useNode()

  return <div ref={connect}>
    <hr {...props} />
  </div>
}

function TextPreview({ ...props }) {
  return <BasePreview {...props}>
    <Preview />
  </BasePreview>
}

export default define('separator', TextPreview, 'hr')
  .palete(<Minus size={16} />, 'Separator', 'Content')
  .property(prop.stylePattern())
  .property(prop.predefined.customClass())
  .property(prop.predefined.visibility())
  .property(prop.predefined.frame())
  .property(prop.predefined.textColor())
  .property(prop.predefined.border())
  .property(prop.predefined.nativeStyle())
  .property(prop.predefined.attributes())
  .defaultProps({
    textColor: 'blue-500',
  })
  .build()
